import { memo } from 'react'
import { Stack, Select, Textarea, Group, Button, Text } from 'components'
import { IconSparkles } from '@tabler/icons-react'
import { useArcTranslation } from 'hooks'

interface AIGeneratorFormProps {
  selectedSchoolTermId: string | null
  selectedGroupId: string | null
  description: string
  schoolTermsData: any[]
  groupsData: any[]
  loadingGroups: boolean
  generating: boolean
  onSchoolTermChange: (value: string | null) => void
  onGroupChange: (value: string | null) => void
  onDescriptionChange: (value: string) => void
  onGenerate: () => void
  onCancel: () => void
}

export const AIGeneratorForm = memo(function AIGeneratorForm({
  selectedSchoolTermId,
  selectedGroupId,
  description,
  schoolTermsData,
  groupsData,
  loadingGroups,
  generating,
  onSchoolTermChange,
  onGroupChange,
  onDescriptionChange,
  onGenerate,
  onCancel
}: AIGeneratorFormProps) {
  const { t } = useArcTranslation()

  return (
    <Stack spacing='md'>
      <Select
        size='md'
        label={
          <Text>
            {t('new_project_page.label_school_term')}{' '}
            <Text color='red' display='inline'>*</Text>
          </Text>
        }
        placeholder={t('new_project_page.placeholder_school_term')}
        data={schoolTermsData}
        value={selectedSchoolTermId}
        onChange={onSchoolTermChange}
      />

      <Select
        size='md'
        label={
          <Text>
            {t('new_project_page.label_group')}{' '}
            <Text color='red' display='inline'>*</Text>
          </Text>
        }
        placeholder={t('new_project_page.placeholder_group')}
        data={groupsData}
        value={selectedGroupId}
        onChange={onGroupChange}
        disabled={!selectedSchoolTermId || loadingGroups}
      />



      <Textarea
        size='md'
        label={
          <Group spacing='xs'>
            <Text>
              {t('new_project_page.practice_description_label')}{' '}
              <Text color='red' display='inline'>*</Text>
            </Text>
          </Group>
        }
        value={description}
        onChange={e => onDescriptionChange(e.currentTarget.value)}
        minRows={4}
        maxRows={8}
        autosize
      />

      <Text size="xs">{t('new_project_page.practice_description_placeholder')}</Text>

      <Group position='right' mt='xl' spacing='sm'>
        <Button
          variant='outline'
          onClick={onCancel}
          disabled={generating}
          size='md'
        >
          {t('general_buttons_cancel')}
        </Button>
        <Button
          onClick={onGenerate}
          disabled={!selectedSchoolTermId || !selectedGroupId || !description.trim() || generating}
          loading={generating}
          leftIcon={<IconSparkles size={18} />}
          size='md'
          color='grape'
        >
          {t('new_project_page.generate_button')}
        </Button>
      </Group>
    </Stack>
  )
})